import { Module } from 'vuex'
import { MenuItem } from '@/components/home/MenuCard.vue'

export interface CartEntry {
  item: MenuItem
  qty: number
}

export interface CartState {
  items: CartEntry[]
}

const cart: Module<CartState, unknown> = {
  namespaced: true,
  state: () => ({ items: [] }),
  getters: {
    count: (s) => s.items.reduce((n, e) => n + e.qty, 0),
    total: (s) => s.items.reduce((n, e) => n + e.item.price * e.qty, 0),
    items: (s) => s.items
  },
  mutations: {
    ADD (state, item: MenuItem) {
      const existing = state.items.find(e => e.item.id === item.id)
      if (existing) existing.qty++
      else state.items.push({ item, qty: 1 })
    },
    DEC (state, index: number) {
      if (state.items[index].qty > 1) state.items[index].qty--
      else state.items.splice(index, 1)
    },
    REMOVE (state, index: number) {
      state.items.splice(index, 1)
    },
    CLEAR (state) {
      state.items = []
    }
  },
  actions: {
    add ({ commit }, item: MenuItem) { commit('ADD', item) },
    dec ({ commit }, index: number) { commit('DEC', index) },
    remove ({ commit }, index: number) { commit('REMOVE', index) },
    clear ({ commit }) { commit('CLEAR') }
  }
}

export default cart
